<it-header
  [slimTitle]="membershipOrganization.title ?? '' | translate"
  [slimTitleLink]="membershipOrganization.url"
  [showSearch]="false"
  [megamenu]="true"
>
  <ng-container slimRightZone>
    <it-dropdown mode="link">
      @let currentLanguage = this.translateService.currentLang;
      <span button>{{ currentLanguage }}</span>
      <ng-container list>
        @for (language of availableLanguages; track language.code) {
          <it-dropdown-item (click)="setLanguage(language.code)" onkeypress="">
            {{ language.label }}
          </it-dropdown-item>
        }
      </ng-container>
    </it-dropdown>

    @if (user()) {
      <it-dropdown color="primary" [fullWidth]="true">
        <div class="d-flex align-items-center gap-2" button>
          @let userFullName =
            user()?.firstName && user()?.lastName
              ? user()?.firstName + ' ' + user()?.lastName
              : ('HEADER.USER' | translate);

          <div itAvatar size="sm" color="secondary">
            <p aria-hidden="true">{{ userInitials() }}</p>
            <span class="visually-hidden">{{ userFullName }}</span>
          </div>
          <span class="user-fullname">{{ userFullName }}</span>
        </div>

        <ng-container list>
          <it-dropdown-item
            iconName="logout"
            iconPosition="left"
            (click)="onLogout()"
            (keydown.enter)="onLogout()"
          >
            <span class="ms-2">{{ 'HEADER.LOGOUT' | translate }}</span>
          </it-dropdown-item>
        </ng-container>
      </it-dropdown>
    }
  </ng-container>
  <ng-container brand>
    <a [href]="logoRedirectUrl()">
      <img src="/assets/logos/header-logo.svg" alt="gies-logo" />
    </a>
  </ng-container>

  <section class="it-socials d-none d-md-flex" rightZone>
    <drw-socials position="header"></drw-socials>
  </section>

  <ng-container navItems>
    @for (link of links(); track link.title) {
      @if (link.canShow) {
        @if (link.children && !link.disabled) {
          <it-navbar-item>
            <it-dropdown mode="nav">
              <span button>{{ link.title | translate }} </span>
              <ng-container list>
                @for (child of link.children; track child.title) {
                  @if (child.disabled && child.tooltipText) {
                    <it-dropdown-item
                      [href]="child.url"
                      [disabled]="child.disabled"
                      [itTooltip]="child.tooltipText! | translate"
                      tooltipPlacement="right"
                      >{{ child.title | translate }}
                    </it-dropdown-item>
                  } @else {
                    <it-dropdown-item [href]="child.url" [disabled]="child.disabled"
                      >{{ child.title | translate }}
                    </it-dropdown-item>
                  }
                }
              </ng-container>
            </it-dropdown>
          </it-navbar-item>
        } @else {
          @let tooltipText = link.disabled && link.tooltipText ? link.tooltipText : null;
          <it-navbar-item [itTooltip]="tooltipText! | translate">
            @let url = link.children ? null : link.url;
            <a
              class="nav-link"
              [href]="url"
              [class.disabled]="link.disabled || !url"
              aria-current="page"
            >
              <span>{{ link.title | translate }}</span>
            </a>
          </it-navbar-item>
        }
      }
    }
  </ng-container>
</it-header>
